export default "assets/images/icons/entity-density-3532a2c3.svg";